import React, { useCallback, useEffect, useState } from 'react';
// Components
import ListItem from './list-item';
// Enums
import ENUMS from '../../../../enums';
// Style
import './index.scss';

export default function List({
  reserves,
  loading,
  onSelectedDetail,
  onSelectedInvoice,
  onSelectTableStatusModal,
}) {
  const handleDetailClick = reserveId => {
    onSelectedDetail(reserveId);
  };

  // const handleInvoiceClick = reserveId => {
  //   onSelectedInvoice(reserveId);
  // };

  const handleTableStatus = (timeId, fromTime, toTime, table) => {
    onSelectTableStatusModal(timeId, fromTime, toTime, table);
  };

  const [multiReservesId, setMultiReservesId] = useState([]);

  const tableDrawer = useCallback(
    reserve =>
      // NOTE: do not control css outside the component and over write many codes just for a small style
      reserve.tables?.map(table => (
        <ListItem
          timeId={table.tableTimeId}
          fromTime={reserve.fromTime}
          toTime={reserve.toTime}
          key={table.num}
          table={table}
          onDetailClick={handleDetailClick}
          // onInvoiceClick={handleInvoiceClick}
          multiReservesId={multiReservesId}
          onChangeTableStatusClick={handleTableStatus}
          discountCodeType={table.discountCodeType}
          discountCodeAmount={table.discountCodeAmount}
          cafeDiscountPercent={table.cafeDiscountPercent}
        />
      )),
    [multiReservesId],
  );

  useEffect(() => {
    const reservesIds = [];
    if (reserves.length > 0) {
      for (let reserve of reserves) {
        for (let table of reserve.tables) {
          if (table.reserveId) {
            reservesIds.push(table.reserveId);
          }
        }
      }
    }
    const uniqueReserveIds = [];
    const res = {};
    reservesIds.forEach(item => {
      if (res[item]) {
        res[item] += 1;
      } else {
        res[item] = 1;
      }
    });
    for (const [key, value] of Object.entries(res)) {
      if (value > 1) {
        uniqueReserveIds.push(key);
      }
    }
    const temp = uniqueReserveIds.map((item, index) => ({
      id: item,
      color: ENUMS.SHEMATIC_RESERVATION.sameReserveColor[index].color,
      backgroundColor:
        ENUMS.SHEMATIC_RESERVATION.sameReserveColor[index].backgroundColor,
    }));
    setMultiReservesId(temp);
  }, [reserves]);

  return (
    <div>
      <table className='shematicTableContainer'>
        <tbody className='shematicTableBody'>
          {loading ? (
            <tr className='trBox trLoadingBox'>در حال دریافت اطلاعات...</tr>
          ) : reserves.length === 0 ? (
            <tr className='trBox trNoDataBox'>
              داده ای برای نمایش وجود ندارد.
            </tr>
          ) : (
            reserves.map(reserve => (
              <tr key={reserve.fromTime}>
                <td>{tableDrawer(reserve)}</td>
                <th>
                  {reserve.fromTime} - {reserve.toTime}
                </th>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
